require("./bootstrap");
require("datatables.net");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("jquery-datatables-checkboxes");
const classie = require("desandro-classie");
import * as Address from "./address";
import * as Toasty from "./toast";
window.Address = Address;
window.Toasty = Toasty;
require("jquery-mask-plugin");
require("jquery-autocomplete");
require("jquery-file-upload");
require("select2");
require("flatpickr");
require("wowjs");
window.moment = require("moment");
jQuery(function () {
    // Init input masks
    //$('.date').mask('00/00/0000');
    $(".time").mask("00:00:00");
    $(".date_time").mask("00/00/0000 00:00:00");
    $(".phone_us").mask("(000) 000-0000");
    $(".zip").mask("00000");
    $(".money").mask("###,##0.00", { reverse: true });

    // Select Autocompletes
    //$(".select2").select2({minimumResultsForSearch: -1});
    $(".select2").select2();

    // TODO: this breaks focus on multiple select2 boxes
    $(document).on("select2:open", (e) => {
        const selectId = e.target.id;
        $(
            ".select2-search__field[aria-controls='select2-" +
                selectId +
                "-results']"
        ).each(function (key, value) {
            value.focus();
        });
    });

    // on first focus (bubbles up to document), open the menu
    $(document).on(
        "focus",
        ".select2-selection.select2-selection--single",
        function (e) {
            $(this)
                .closest(".select2-container")
                .siblings("select:enabled")
                .select2("open");
        }
    );

    $("select.select2_tags").select2({
        tags: true,
    });

    // steal focus during close - only capture once and stop propogation
    $("select.select2").on("select2:closing", function (e) {
        $(e.target)
            .data("select2")
            .$selection.one("focus focusin", function (e) {
                e.stopPropagation();
            });
    });

    flatpickr(".datepicker", {
        altFormat: "n-j-Y",
        altInput: true,
        allowInput: true,
        onReady: function () {
            $(this._input).removeClass("form-control");
        },
    });

    flatpickr(".month_picker", {
        altFormat: "n-j-Y",
        altInput: true,
        allowInput: true,
        onReady: function () {
            $(this._input).removeClass("form-control");
        },
        disable: [
            function (date) {
                return !(date.getDate() === 1);
            },
        ],
    });

    $(".custom-file-input").on("change", function () {
        var fileName = $(this).val().split("\\").pop();
        $(this)
            .siblings(".custom-file-label")
            .addClass("selected")
            .html(fileName);
    });

    // Init tooltips
    $('[data-toggle="tooltip"]').tooltip({
        container: "body",
        trigger: "manual",
    });

    // Animation for input fields
    // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
        (function () {
            // Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            String.prototype.trim = function () {
                return this.replace(rtrim, "");
            };
        })();
    }

    // Delayed for now until fix is found
    setTimeout(function () {
        [].slice
            .call(document.querySelectorAll("input.input__field"))
            .forEach(function (inputEl) {
                // in case the input is already filled..
                if (inputEl.value.trim() !== "") {
                    classie.add(inputEl.parentNode, "input--filled");
                }

                // events:
                inputEl.addEventListener("focus", onInputFocus);
                inputEl.addEventListener("blur", onInputBlur);
            });
    }, 1000);

    function onInputFocus(ev) {
        classie.add(ev.target.parentNode, "input--filled");
    }

    function onInputBlur(ev) {
        if (ev.target.value.trim() === "") {
            classie.remove(ev.target.parentNode, "input--filled");
        }
    }

    $(".report-export-button").on("click", function () {
        url = new URL(window.location.href);
        url.searchParams.set("export", 1);
        window.location.href = url.href;
    });

    //smooth scrolling
    $(".scroll").on("click", function () {
        if (
            location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "") ||
            location.hostname == this.hostname
        ) {
            var target = $(this.hash);
            target = target.length
                ? target
                : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
                $("html,body").animate(
                    {
                        // Adjust offset to top of page and speed
                        scrollTop: target.offset().top - 100,
                    },
                    1000
                );
                return false;
            }
        }
    });

    $(".popover-dismiss").popover({
        trigger: "focus",
    });

    // COPY TEXT TO CLIPBOARD ON CLICK
    window.copyToClipboardFF = function copyToClipboardFF(text) {
        window.prompt("Copy to clipboard: Ctrl C, Enter", text);
    };

    window.copyToClipboard = function copyToClipboard(selector) {
        var success = true,
            range = document.createRange(),
            input = $("#" + selector),
            selection;

        // For IE.
        if (window.clipboardData) {
            window.clipboardData.setData("Text", input.val());
        } else {
            try {
                success = navigator.clipboard.writeText(input.val());
            } catch (e) {
                copyToClipboardFF(input.val());
            }
            if (success) {
                // remove temp element.
                // show notification
                $("#cpTool-" + selector).tooltip("enable");
                $("#cpTool-" + selector).tooltip("open");
                setTimeout(function () {
                    $("#cpTool-" + selector).tooltip("disable");
                }, 2000);
            }
        }
    };
});
